import React from 'react';

const ArrowSVG = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="156pt"
      height="74pt"
      viewBox="0 0 156 74"
      version="1.1"
      className={className || ""}
    >
      <g id="#00b6e4ff">
        <path
          fill="#00b6e4"
          opacity="1.00"
          d=" M 35.23 0.00 L 38.61 0.00 C 40.80 1.39 41.60 4.52 39.44 6.34 C 30.52 15.36 21.51 24.30 12.54 33.28 C 58.72 33.11 104.91 33.27 151.09 33.20 C 152.91 33.00 154.52 33.87 156.00 34.82 L 156.00 38.45 C 155.09 40.36 153.06 40.99 151.08 40.80 C 104.90 40.73 58.72 40.88 12.54 40.73 C 21.51 49.70 30.52 58.64 39.44 67.66 C 41.60 69.46 40.71 72.38 38.84 74.00 L 35.27 74.00 C 26.94 66.26 19.18 57.93 11.02 50.01 C 7.37 45.98 2.82 42.69 0.00 37.95 L 0.00 36.04 C 2.68 31.49 7.03 28.32 10.54 24.47 C 18.84 16.38 26.79 7.93 35.23 0.00 Z"
        />
      </g>
    </svg>
  );
};

export default ArrowSVG;
